import { ORG_CONFIG_PERMISSIONS } from '@shared/permissions/permissions';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Wallet } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/financials')({
    staticData: {
        breadcrumb: {
            title: 'Financial',
            inactive: true,
        },
        permissions: ORG_CONFIG_PERMISSIONS,
        ui: {
            icon: Wallet,
        },
    },
    component: Outlet,
});
